export const titulos = [
    { "id": 0, "value": "Sr." },
    { "id": 1, "value": "Sra." },
    { "id": 2, "value": "Srta." },
    { "id": 3, "value": "Ing." },
    { "id": 4, "value": "Lic." },
    { "id": 5, "value": "Doc." }
];

export const dias = [
    { "id": "01", "value": "01" },
    { "id": "02", "value": "02" },
    { "id": "03", "value": "03" },
    { "id": "04", "value": "04" },
    { "id": "05", "value": "05" },
    { "id": "06", "value": "06" },
    { "id": "07", "value": "07" },
    { "id": "08", "value": "08" },
    { "id": "09", "value": "09" },
    { "id": "10", "value": "10" },
    { "id": "11", "value": "11" },
    { "id": "12", "value": "12" },
    { "id": "13", "value": "13" },
    { "id": "14", "value": "14" },
    { "id": "15", "value": "15" },
    { "id": "16", "value": "16" },
    { "id": "17", "value": "17" },
    { "id": "18", "value": "18" },
    { "id": "19", "value": "19" },
    { "id": "20", "value": "20" },
    { "id": "21", "value": "21" },
    { "id": "22", "value": "22" },
    { "id": "23", "value": "23" },
    { "id": "24", "value": "24" },
    { "id": "25", "value": "25" },
    { "id": "26", "value": "26" },
    { "id": "27", "value": "27" },
    { "id": "28", "value": "28" },
    { "id": "29", "value": "29" },
    { "id": "30", "value": "30" },
    { "id": "31", "value": "31" }
];

export const meses = [
    { "id": "01", "value": "Ene" },
    { "id": "02", "value": "Feb" },
    { "id": "03", "value": "Mar" },
    { "id": "04", "value": "Abr" },
    { "id": "05", "value": "May" },
    { "id": "06", "value": "Jun" },
    { "id": "07", "value": "Jul" },
    { "id": "08", "value": "Ago" },
    { "id": "09", "value": "Sep" },
    { "id": "10", "value": "Oct" },
    { "id": "11", "value": "Nov" },
    { "id": "12", "value": "Dic" }
];

export const tipoVi = [
    { "id": "O", "value": "Propietario" },
    { "id": "P", "value": "Padres" },
    { "id": "R", "value": "Rentada" },
    { "id": "X", "value": "Otros (prestada)" }
];

export const tipoEmpresa = [
    { "id": "01", "value": "RAMO FINANCIERO" },
    { "id": "02", "value": "RAMO INDUSTRIAL" },
    { "id": "03", "value": "RAMO COMERCIAL" },
    { "id": "04", "value": "TRANSPORTE" },
    { "id": "05", "value": "MEDIOS DE COMUNICACIÓN" },
    { "id": "06", "value": "TURISMO" },
    { "id": "07", "value": "SERVICIO" },
    { "id": "08", "value": "MILITAR" },
    { "id": "09", "value": "GOBIERNO" },
    { "id": "10", "value": "OTROS" },
    { "id": "11", "value": "JUBILADO" },
    { "id": "12", "value": "AMA DE CASA" },
    { "id": "13", "value": "ESTUDIANTE" },
    { "id": "14", "value": "DESEMPLEADO" }
];

export const ocupacion = [
    { "id": "01", "value": "Profesionista" },
    { "id": "02", "value": "Ejecutivo de Negocio" },
    { "id": "03", "value": "Cuenta Propia" },
    { "id": "04", "value": "Profesionales" },
    { "id": "05", "value": "Ventas" },
    { "id": "06", "value": "Labores Clasificadas" },
    { "id": "07", "value": "Mano de Obra No Calificada" },
    { "id": "08", "value": "Oficinista" },
];

export const estadosAbreviacion = [
    { "inicial": "AG", "completo": "aguascalientes" },
    { "inicial": "BC", "completo": "baja california" },
    { "inicial": "BS", "completo": "baja california sur" },
    { "inicial": "CH", "completo": "chihuahua" },
    { "inicial": "CI", "completo": "chiapas" },
    { "inicial": "CL", "completo": "colima" },
    { "inicial": "CO", "completo": "coahuila" },
    { "inicial": "CP", "completo": "campeche" },
    { "inicial": "DF", "completo": "ciudad de méxico" },
    { "inicial": "DU", "completo": "durango" },
    { "inicial": "EM", "completo": "méxico" },
    { "inicial": "GR", "completo": "guerrero" },
    { "inicial": "GT", "completo": "guanajuato" },
    { "inicial": "HG", "completo": "hidalgo" },
    { "inicial": "JA", "completo": "jalisco" },
    { "inicial": "MI", "completo": "michoacán de ocampo" },
    { "inicial": "MO", "completo": "morelos" },
    { "inicial": "NA", "completo": "nayarit" },
    { "inicial": "NL", "completo": "nuevo león" },
    { "inicial": "OA", "completo": "oaxaca" },
    { "inicial": "PU", "completo": "puebla" },
    { "inicial": "QT", "completo": "querétaro" },
    { "inicial": "QR", "completo": "quintana roo" },
    { "inicial": "SI", "completo": "sinaloa" },
    { "inicial": "SL", "completo": "san luis potosí" },
    { "inicial": "SO", "completo": "sonora" },
    { "inicial": "TA", "completo": "tamaulipas" },
    { "inicial": "TB", "completo": "tabasco" },
    { "inicial": "TL", "completo": "tlaxcala" },
    { "inicial": "VE", "completo": "veracruz de ignacio de la llave" },
    { "inicial": "YU", "completo": "yucatán" },
    { "inicial": "ZA", "completo": "zacatecas" }
]